module.exports = __webpack_public_path__ + "resources/img/img_ahnlabv3_net_server_en.e910eb6e2ff8ae108af1f5ebce781509.png";